import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LocalStorageService } from "angular-web-storage";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { RestEndpoint } from "../../../constants/rest-endpoint.constants";
import { FeatureNames } from "../../models/feature-names.enum";
import { LocalStorageKeys } from "../../utils/local.storage.keys";
import { PaymentTypesEnum } from "../../models/PaymentTypeEnum";
import { PaymentTypeConfig, PaymentTypesConfig } from "../../models/payment-types-config.model";
import { BaseCurrency } from "../../models/base-currency.model";

@Injectable()
export class FeaturesStatusService {

    constructor(
        private readonly http: HttpClient,
        private readonly storage: LocalStorageService
    ) { }

    public getFeatureStatus(featureName: FeatureNames, forceLoad: boolean = false): Observable<boolean> {
        if (this.storage.get(LocalStorageKeys.FEATURE_STATUS + featureName)) {
            return of(this.storage.get(LocalStorageKeys.FEATURE_STATUS + featureName));
        }

        return this.http.get(RestEndpoint.getFeatureStatus, {
            params: { 'featureName': featureName }
        })
            .pipe(
                map((data: { value: boolean }) => {
                    this.storage.set(LocalStorageKeys.FEATURE_STATUS + featureName, data?.value);
                    return data?.value;
                }),
                catchError((err) => {
                    throw (err);
                })
            );
    }

    public getAllFeatureStatus(): Observable<any> {
        return this.http.get(RestEndpoint.getAllFeatureStatus)
            .pipe(
                map((data) => {
                    return data;
                }),
                catchError((err) => {
                    throw (err);
                })
            );
    }

    public getBaseCurrency(forceLoad: boolean = false): Observable<BaseCurrency> {
        const cached = this.storage.get(LocalStorageKeys.FEATURE_STATUS + 'baseCurrency');
        if (cached && !forceLoad) {
            return of(cached);
        }

        return this.http.get(RestEndpoint.getBaseCurrency)
            .pipe(
                map((data: { value: 'BRL' | 'USD' | 'EUR' }) => {
                    this.storage.set(LocalStorageKeys.FEATURE_STATUS + 'baseCurrency', data?.value);
                    return data?.value;
                }),
                catchError((err) => {
                    throw (err);
                })
            );
    }

    public getPaymentTypes<T extends PaymentTypesEnum | undefined = undefined>(
        especificPaymentType?: T
    ): Observable<T extends PaymentTypesEnum ? PaymentTypeConfig | undefined : PaymentTypesConfig> {
        const cached: PaymentTypesConfig | null = this.storage.get(LocalStorageKeys.PAYMENT_TYPES);
        if (cached) {
            return of(especificPaymentType ? cached[especificPaymentType] : cached) as Observable<
                T extends PaymentTypesEnum ? PaymentTypeConfig | undefined : PaymentTypesConfig
            >;
        }

        return this.http.get<PaymentTypesConfig>(RestEndpoint.getPaymentTypes)
            .pipe(
                map((data: PaymentTypesConfig) => {
                    this.storage.set(LocalStorageKeys.PAYMENT_TYPES, data);
                    return (especificPaymentType ? data?.[especificPaymentType] : data) as
                        T extends PaymentTypesEnum ? PaymentTypeConfig | undefined : PaymentTypesConfig;
                }),
                catchError((err) => {
                    throw (err);
                })
            );
    }
}
